import React from "react";
import { Card, CardHeader, CardBody, Container } from "reactstrap";
import TableWrapper from "@/utils/TableWrapper";
import type { TableWrapperProps } from "@/utils/TableWrapper";

export type DisplaySitesViewProps<TData> = {
  sites?: TableWrapperProps<TData>["data"];
  columns: TableWrapperProps<TData>["columns"];
};

const DisplaySitesView = <TData,>({ sites, columns }: DisplaySitesViewProps<TData>) => {
  return (
    <Container className="mt--6" fluid>
      <Card>
        <CardHeader>
          <h3 className="mb-0">All Sites</h3>
        </CardHeader>
        <CardBody>
          <TableWrapper data={sites} columns={columns} />
        </CardBody>
      </Card>
    </Container>
  );
};

export default DisplaySitesView;
